import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { deleteStudyApi } from "@/API/deleteStudyApi";
import { useInvalidateQueries } from "@/hooks/helperHooks/useInvalidateQueries";
import { ShowNotification } from "@/components/ShowNotification";

export const useDeleteStudy = () => {
  const [deleteStudyId, setDeleteStudyId] = useState<string | null>(null);
  const [isDeleteStudyModalOpen, setIsDeleteStudyModalOpen] = useState(false);
  const { invalidateStudies } = useInvalidateQueries();

  const { mutateAsync: deleteStudyMutation } = useMutation({
    mutationFn: deleteStudyApi,
    onSuccess: (response) => {
      if (response.status === "success") {
        setIsDeleteStudyModalOpen(false);
        setDeleteStudyId(null);
        ShowNotification({
          title: "Study deleted!",
          message: "Your study has been deleted.",
          color: "info",
        });
      } else {
        ShowNotification({
          title: "Error",
          message: "An unexpected error occurred while deleting the study.",
          color: "error",
        });
      }
    },
    onError: (error) => {
      console.error("Error deleting study:", error);
      ShowNotification({
        title: "Error",
        message: "An error occurred while deleting the study.",
        color: "error",
      });
    },
    onSettled: () => {
      invalidateStudies();
    },
  });

  const confirmDeleteStudy = async (studyId: string) => {
    try {
      await deleteStudyMutation(studyId);
    } catch (error) {
      console.error("Error confirming study deletion:", error);
    }
  };

  return {
    confirmDeleteStudy,
    isDeleteStudyModalOpen,
    setIsDeleteStudyModalOpen,
    deleteStudyId,
    setDeleteStudyId,
  };
};
